import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/service.css';

import heroVideo from '../assets/video/Hero.mp4';

const Services = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const [selectedLocation, setSelectedLocation] = useState('Select Location');
  const [selectedCategory, setSelectedCategory] = useState('Services');
  const navigate = useNavigate();
  const carouselRef = useRef(null);
  const timerRef = useRef(null);

  // Services data
  const services = [
    {
      id: 1,
      name: 'Mobile Repair Service',
      price: '32999',
      mrp: '42999',
      save: '10000',
      off: '23%',
      img: '/assets/image/phone1.png',
    },
    {
      id: 2,
      name: 'Home Cleaning Service',
      price: '16999',
      mrp: '24999',
      save: '8000',
      off: '32%',
      img: '/assets/image/phone2.png',
    },
    {
      id: 3,
      name: 'Laptop Servicing',
      price: '16999',
      mrp: '24999',
      save: '8000',
      off: '32%',
      img: '/assets/image/phone3.png',
    },
    {
      id: 4,
      name: 'AC Full Service',
      price: '31999',
      mrp: '40999',
      save: '9000',
      off: '22%',
      img: '/assets/image/phone4.png',
    },
    {
      id: 5,
      name: 'Plumbing Service',
      price: '42999',
      mrp: '52999',
      save: '10000',
      off: '19%',
      img: '/assets/image/phone5.png',
    },
  ];

  // Section titles
  const sectionTitles = ['Smartphones', 'Laptops', 'Groceries'];

  // Service sets
  const productSets = [
    [
      {
        id: 1,
        name: 'Full House Cleaning',
        price: '129999',
        old: '279999',
        img: 'https://images.unsplash.com/photo-1610945415295-d9bbf067e59c?w=400',
      },
      {
        id: 2,
        name: 'Kitchen Deep Cleaning',
        price: '169999',
        old: '249999',
        img: 'https://images.unsplash.com/photo-1598327105666-5b89351aff97?w=400',
      },
      {
        id: 3,
        name: 'Bathroom Cleaning',
        price: '199999',
        old: '249999',
        img: 'https://images.unsplash.com/photo-1592750475338-74b7b21085ab?w=400',
      },
      {
        id: 4,
        name: 'Floor Polishing',
        price: '89999',
        old: '119999',
        img: 'https://images.unsplash.com/photo-1583394838336-acd977736f90?w=400',
      },
      {
        id: 5,
        name: 'Garden Maintenance',
        price: '79999',
        old: '99999',
        img: 'https://images.unsplash.com/photo-1598327105854-c8674faddf74?w=400',
      },
    ],

    // Electronics Services Section
    [
      {
        id: 6,
        name: 'Laptop Repair',
        price: '299999',
        old: '349999',
        img: 'https://images.unsplash.com/photo-1541807084-5c52b6b3adef?w=400',
      },
      {
        id: 7,
        name: 'Mobile Repair',
        price: '159999',
        old: '199999',
        img: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=400',
      },
      {
        id: 8,
        name: 'TV Mounting',
        price: '179999',
        old: '219999',
        img: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=400',
      },
      {
        id: 9,
        name: 'AC Servicing',
        price: '219999',
        old: '259999',
        img: 'https://images.unsplash.com/photo-1593640408182-31c70c8268f5?w=400',
      },
      {
        id: 10,
        name: 'LED TV Repair',
        price: '189999',
        old: '229999',
        img: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=400',
      },
    ],

    // Repair Services
    [
      {
        id: 11,
        name: 'Washing Machine Repair',
        price: '89999',
        old: '119999',
        img: 'https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?w=400',
      },
      {
        id: 12,
        name: 'Fridge Repair',
        price: '129999',
        old: '159999',
        img: 'https://images.unsplash.com/photo-1571175443880-49e1d25b2bc5?w=400',
      },
      {
        id: 13,
        name: 'Microwave Repair',
        price: '69999',
        old: '89999',
        img: 'https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=400',
      },
      {
        id: 14,
        name: 'Water Pump Repair',
        price: '89999',
        old: '109999',
        img: 'https://images.unsplash.com/photo-1585730062411-9c8d8c1f88c9?w=400',
      },
      {
        id: 15,
        name: 'Fan Repair',
        price: '29999',
        old: '39999',
        img: 'https://images.unsplash.com/photo-1610057099431-d73a1c9d2f2f?w=400',
      },
    ],
  ];

  // Carousel images
  const carouselImages = [
    'https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1600&q=80',
    'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1600&q=80',
    'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?auto=format&fit=crop&w=1600&q=80',
  ];

  // Locations
  const locations = [
    'Colombo',
    'Kandy',
    'Galle',
    'Jaffna',
    'Negombo',
    'Matara',
    'Kurunegala',
    'Anuradhapura',
    'Polonnaruwa',
    'Batticaloa',
  ];

  // Service categories
  const serviceCategories = [
    'Smartphones',
    'Laptops',
    'Groceries',
    'Home Appliances',
  ];

  // Promo banners
  const promoBanners = [
    {
      id: 1,
      brand: 'CLEANING',
      title: 'UP to 80% OFF',
      image:
        'https://images.unsplash.com/photo-1616348436168-de43ad0db179?auto=format&fit=crop&w=800&q=80',
    },
    {
      id: 2,
      brand: 'REPAIR',
      title: 'UP to 80% OFF',
      image:
        'https://images.unsplash.com/photo-1592750475338-74b7b21085ab?auto=format&fit=crop&w=800&q=80',
    },
    {
      id: 3,
      brand: 'HOME CARE',
      title: 'UP to 80% OFF',
      image:
        'https://images.unsplash.com/photo-1605787020600-b9ebd5df1d1b?auto=format&fit=crop&w=800&q=80',
    },
  ];

  // Carousel autoplay
  useEffect(() => {
    if (isPlaying) {
      timerRef.current = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
      }, 3500);
    }

    return () => clearInterval(timerRef.current);
  }, [isPlaying]);

  const handlePrevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + carouselImages.length) % carouselImages.length
    );
    resetAutoPlay();
  };

  const handleNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    resetAutoPlay();
  };

  const handleDotClick = (index) => {
    setCurrentSlide(index);
    resetAutoPlay();
  };

  const resetAutoPlay = () => {
    setIsPlaying(false);
    clearInterval(timerRef.current);
    setTimeout(() => setIsPlaying(true), 5000);
  };

  const handleAddToCart = (serviceName, event) => {
    event.stopPropagation();
    const button = event.target;
    const originalHTML = button.innerHTML;

    button.innerHTML = '<i class="fas fa-check"></i> Added!';
    button.style.background = '#1a5c38';
    button.disabled = true;

    setTimeout(() => {
      button.innerHTML = originalHTML;
      button.style.background = '#2a7c4b';
      button.disabled = false;
    }, 2000);

    console.log(`Added ${serviceName} to cart`);
  };

  const handleServiceClick = (serviceId) => {
    navigate(`/view-service/${serviceId}`);
  };

  const handleViewAll = (category) => {
    navigate(`/services?category=${encodeURIComponent(category)}`);
  };

  const formatPrice = (price) => parseInt(price).toLocaleString();

  const calculateSaveAmount = (oldPrice, price) => {
    return formatPrice(parseInt(oldPrice) - parseInt(price));
  };

  const handleLocationSelect = (location) => {
    setSelectedLocation(location);
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
  };

  return (
    <div className='products-container'>
      {/* HERO SECTION */}
      <section className='hero-section'>
        <div className='hero-left card'>
          <video autoPlay muted loop playsInline className='hero-video'>
            <source src={heroVideo} type='video/mp4' />
          </video>
          <div className='video-overlay'></div>
        </div>

        <div className='hero-right card'>
          <div
            className='carousel'
            ref={carouselRef}
            onMouseEnter={() => setIsPlaying(false)}
            onMouseLeave={() => setIsPlaying(true)}
          >
            <div
              className='slides'
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {carouselImages.map((image, index) => (
                <div key={index} className='slide'>
                  <img src={image} alt={`Slide ${index + 1}`} />
                  <div className='slide-content'></div>
                </div>
              ))}
            </div>

            <button className='nav-btn prev' onClick={handlePrevSlide}>
              ‹
            </button>
            <button className='nav-btn next' onClick={handleNextSlide}>
              ›
            </button>

            <div className='dots-container'>
              {carouselImages.map((_, index) => (
                <button
                  key={index}
                  className={`dot ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => handleDotClick(index)}
                ></button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* PILLS SECTION */}
      <section className='pills-section'>
        <div className='dropdown'>
          <button className='pill'>{selectedLocation}</button>
          <div className='dropdown-menu'>
            {locations.map((location, index) => (
              <button
                key={index}
                className='dropdown-item'
                onClick={() => handleLocationSelect(location)}
              >
                {location}
              </button>
            ))}
          </div>
        </div>

        <div className='dropdown'>
          <button className='pill'>{selectedCategory}</button>
          <div className='dropdown-menu'>
            {serviceCategories.map((category, index) => (
              <button
                key={index}
                className='dropdown-item'
                onClick={() => handleCategorySelect(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* SERVICE SECTIONS */}
      {sectionTitles.map((title, sectionIndex) => (
        <section key={title} className='product-section'>
          <div className='section-header'>
            <h2>
              Grab the best deal on <span className='accent'>{title}</span>
            </h2>
            <button
              className='view-all-btn'
              onClick={() => handleViewAll(title)}
            >
              View All →
            </button>
          </div>

          {/* Service Grid */}
          <div className='products-grid'>
            {productSets[sectionIndex].map((service) => (
              <div
                key={service.id}
                className='product-card'
                onClick={() => handleServiceClick(service.id)}
              >
                <div className='offer-badge'>Best Deal</div>

                <img
                  src={service.img}
                  alt={service.name}
                  className='product-image'
                />

                <h3 className='product-name'>{service.name}</h3>

                <div className='price-section'>
                  <span className='current-price'>
                    LKR {formatPrice(service.price)}
                  </span>
                  <span className='old-price'>
                    LKR {formatPrice(service.old)}
                  </span>
                </div>

                <p className='save-text'>
                  Save - LKR {calculateSaveAmount(service.old, service.price)}
                </p>

                <button
                  className='add-to-cart-btn'
                  onClick={(e) => handleAddToCart(service.name, e)}
                >
                  <i className='fas fa-shopping-cart'></i> Add to Cart
                </button>
              </div>
            ))}
          </div>

          {/* Promo banners */}
          {sectionIndex === 1 && (
            <div className='promo-banners'>
              {promoBanners.map((promo) => (
                <div
                  key={promo.id}
                  className='promo-banner'
                  style={{
                    backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('${promo.image}')`,
                  }}
                >
                  <div className='promo-chip'>{promo.brand}</div>
                  <h3 className='promo-title'>{promo.title}</h3>
                </div>
              ))}
            </div>
          )}
        </section>
      ))}
    </div>
  );
};

export default Services;
